/* --------------------------------------------------------------------------
   efx-quote-wizard.js — T-QUOTE-WIZARD 2026-09-01.
   Turns the "Get a quote" form into one question per screen. Draft #131236954194.

   Owner: "duzo informacji na raz — trzeba zrobic w steps krotkie latwe szybkie
   do zaznaczenia jak typeform". Typeform's PACE is the reference, not its
   decoration: one question, a straight answer, forward.

   PROGRESSIVE ENHANCEMENT — read this before changing anything here.
   snippets/efx-quote-form.liquid renders ONE honest form with every question
   visible and a native {% form 'contact' %} submit. This file re-parents that
   same markup into a paged frame. It creates no field, renames no field and
   deletes no field, so there is exactly one definition of the form. If this
   file never loads, never parses, or throws, `efq-wizard` is never set on
   <html>, the CSS that hides non-current steps never applies, and what the
   buyer gets is the long form — complete, valid and submittable.

   WHAT IT ADDS
     - a progress rail + "Step N of M" that counts the branch honestly: the
       fireplace-type question only exists for doors and screens, and the photo
       step only exists once its own JS has bound it, so M is recomputed on
       every category change and never under-claims.
     - Back / Next that keep every answer, because nothing is ever destroyed:
       paging is `hidden` on a fieldset, and the values live in the one form.
     - a review step that prints what is about to be sent, with Edit per row.
     - the measurement step's wording branching per category (the JSON lives in
       the Liquid, not here) while contact[Width] / contact[Height] stay put.

   KEYBOARD
     Enter in a text field advances (and sends on the last step). Arrow keys
     inside a choice group are the browser's own radio roving — which is why
     auto-advance fires on `click` with detail > 0 (a real pointer) and never on
     `change`: arrowing through three options must not fling you forward three
     screens. Escape is left alone so the dialog still closes.

   CLS
     The frame's height is fixed and the nav sits outside the scrolling step
     area, so no element changes position when a step changes. The transition is
     opacity + transform only, neither of which shifts layout.
   -------------------------------------------------------------------------- */
(function () {
  'use strict';

  var docEl = document.documentElement;

  /* Set at parse time, exactly as efx-quote.js sets .efq-js: the CSS that hides
     non-current steps must not be able to apply unless this file ran. In the
     modal this file is fetched alongside the markup and lands before injection,
     so there is no frame in which the long form paints. */
  docEl.classList.add('efq-wizard');

  var W = null;              /* the live wizard instance, or null */

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function text(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  /* ---------------------------------------------------------------- build -- */
  function build(form) {
    var steps = [].slice.call(form.querySelectorAll('[data-efw-step]'));
    if (steps.length < 2) return null;

    var branch = {};
    var bs = form.querySelector('[data-efw-branch]');
    if (bs) { try { branch = JSON.parse(bs.textContent); } catch (e) { branch = {}; } }

    /* -- frame ---------------------------------------------------------- */
    var frame = document.createElement('div');
    frame.className = 'efw';
    frame.innerHTML =
      '<div class="efw-prog">' +
        '<div class="efw-prog__rail"><span class="efw-prog__fill" data-efw-fill></span></div>' +
        '<p class="efw-prog__label" data-efw-count>' +
          '<span class="efw-sr-only" data-efw-live role="status" aria-live="polite"></span>' +
        '</p>' +
      '</div>' +
      '<div class="efw-area" data-efw-area></div>' +
      /* The error line is its own always-present row with a reserved height:
         a message that appears must not push the buttons, or answering wrongly
         would cost a layout shift. */
      '<div class="efw-nav">' +
        '<p class="efw-err" data-efw-err role="alert"></p>' +
        '<div class="efw-nav__row">' +
          '<button type="button" class="efw-back" data-efw-back>' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 12H5M11 18l-6-6 6-6"/></svg>Back' +
          '</button>' +
          '<div class="efw-nav__end"></div>' +
        '</div>' +
      '</div>';

    /* The browser validates the WHOLE form on a submit attempt, including the
       required radios sitting in steps that are currently `hidden`, and then
       logs "An invalid form control with name=... is not focusable" because it
       cannot point a bubble at them. Measured 2026-09-01: five such errors from
       one early submit (logs/t-quote/f1.json), against a 0-console-errors gate.
       So once the wizard owns the paging it also owns the validation: `validate`
       below checks the step you are on, `reportValidity` is only ever called on
       a control that is actually on screen, and the submit handler re-checks
       every step and jumps to the first bad one before letting the post go. With
       JS off this attribute is never set and the native `required` is the gate,
       exactly as before. */
    form.setAttribute('novalidate', '');

    steps[0].parentNode.insertBefore(frame, steps[0]);
    var area = frame.querySelector('[data-efw-area]');
    for (var i = 0; i < steps.length; i++) area.appendChild(steps[i]);

    /* The submit button becomes the nav's primary action on the last step; the
       privacy line moves to the bottom of that step, where it is read. Both are
       moved, not duplicated — the no-JS markup still owns them. */
    var submitWrap = form.querySelector('[data-efw-submit]');
    var sendBtn = form.querySelector('[data-efw-send]');
    var scheduleBtn = form.querySelector('[data-efq-schedule-send]');
    var fine = form.querySelector('[data-efw-fine]');
    var navEnd = frame.querySelector('.efw-nav__end');
    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'efx-btn efw-next';
    nextBtn.setAttribute('data-efw-next', '');
    nextBtn.innerHTML = 'Next<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    navEnd.appendChild(nextBtn);
    if (sendBtn) { sendBtn.classList.add('efw-send'); navEnd.appendChild(sendBtn); }
    if (scheduleBtn) { scheduleBtn.classList.add('efw-send'); navEnd.appendChild(scheduleBtn); }
    var reviewStep = form.querySelector('[data-efw-key="contact"]');
    if (fine && reviewStep) reviewStep.appendChild(fine);
    if (submitWrap && submitWrap.parentNode) submitWrap.parentNode.removeChild(submitWrap);

    var w = {
      form: form,
      frame: frame,
      area: area,
      steps: steps,
      branch: branch,
      fill: frame.querySelector('[data-efw-fill]'),
      count: frame.querySelector('[data-efw-count]'),
      live: frame.querySelector('[data-efw-live]'),
      err: frame.querySelector('[data-efw-err]'),
      back: frame.querySelector('[data-efw-back]'),
      next: frame.querySelector('[data-efw-next]'),
      send: sendBtn,
      schedule: scheduleBtn,
      at: steps[0],
      timer: 0
    };

    /* Wizard-mode legends. Both strings live in the Liquid; this only chooses. */
    for (var j = 0; j < steps.length; j++) {
      var wt = steps[j].getAttribute('data-efw-wiztitle');
      if (!wt) continue;
      var lg = steps[j].querySelector('.efq-step__legend');
      if (lg) lg.textContent = wt;
    }

    /* The modal panel takes a fixed height so nothing can move when a step
       changes. efx-quote-dialog.js clears this class whenever it replaces the
       body, so the confirmation state still shrinks to its content. */
    var dlg = frame.closest ? frame.closest('dialog') : null;
    if (dlg) dlg.classList.add('efqd-wiz');

    return w;
  }

  /* ------------------------------------------------------------ branching -- */
  function category(w) {
    var el = w.form.querySelector('input[name="contact[Quote for]"]:checked');
    return el ? el.value : '';
  }

  function available(w, step) {
    if (step.hasAttribute('data-efw-jsonly')) {
      /* the photo step exists only once efx-quote.js has actually bound it */
      return step.getAttribute('data-efq-photo-ready') === '1';
    }
    var cond = step.getAttribute('data-efq-cond');
    if (cond) {
      /* Before a category is picked the branch is unknown, and "Step 1 of 6"
         followed by "Step 2 of 7" is exactly the dishonesty the brief forbids.
         Count the branching question until the first answer settles it - the
         total may shrink, it may never grow. */
      var c = category(w);
      return c ? cond.split('|').indexOf(c) !== -1 : true;
    }
    return true;
  }
  function order(w) {
    var out = [];
    for (var i = 0; i < w.steps.length; i++) if (available(w, w.steps[i])) out.push(w.steps[i]);
    return out;
  }

  /* The measurement step is asked in every category — only its words change.
     Keys never change, and contact[Measurement] records what the two numbers
     describe so a mantel's 60 in is never read as a fireplace opening. */
  function applyBranch(w) {
    var b = w.branch[category(w)];
    var step = w.form.querySelector('[data-efw-key="size"]');
    if (!step) return;
    var t = step.querySelector('[data-efw-title]');
    var wl = step.querySelector('[data-efw-wlabel]');
    var hl = step.querySelector('[data-efw-hlabel]');
    var ws = step.querySelector('[data-efw-wsub]');
    var hs = step.querySelector('[data-efw-hsub]');
    var df = step.querySelector('[data-efw-dfield]');
    var dl = step.querySelector('[data-efw-dlabel]');
    var ds = step.querySelector('[data-efw-dsub]');
    var link = step.querySelector('[data-efw-helplink]');
    var mf = step.querySelector('[data-efw-mfield]');
    if (!b) return;
    if (t) t.textContent = b.t;
    if (wl) wl.textContent = b.w || 'Width';
    if (hl) hl.textContent = b.b;
    if (ws) ws.textContent = b.ws;
    if (hs) hs.textContent = b.hs;
    /* R7: a third field only where the branch names one (gas logs, inserts); the
       key contact[Depth] never changes and an emptied field posts nothing. */
    if (df) { var wantD = !!b.d; df.hidden = !wantD; if (!wantD) { var di = df.querySelector('input'); if (di) di.value = ''; } }
    if (dl && b.d) dl.textContent = b.d;
    if (ds && b.ds) ds.textContent = b.ds;
    /* the guide link exists only where a guide exists — no link is honest, a doors guide under a fire pit is not */
    if (link) { if (b.help) { link.href = b.help; link.hidden = false; } else link.hidden = true; }
    if (mf) mf.value = b.m;
  }

  /* A buyer who ticked "I have not measured yet" is exactly the buyer the photo
     step is for. Same step, different sentence. */
  function applyPhotoHelp(w) {
    var p = w.form.querySelector('[data-efw-photohelp]');
    var flag = w.form.querySelector('[data-efq-nomeasure]');
    if (!p) return;
    p.textContent = (flag && flag.checked)
      ? 'Then a photo does most of the work. Take it straight on from a few feet back and we will size it with you.'
      : 'Add a straight-on photo from a few feet back so our specialist can see the opening and surrounding area.';
  }

  /* --------------------------------------------------------------- paging -- */
  function isChoiceOnly(step) {
    return !!step.querySelector('.efq-choices') &&
           !step.querySelector('input[type="text"], input[type="email"], input[type="tel"], textarea, input[type="checkbox"], input[type="file"]');
  }

  function say(w, msg) {
    w.err.textContent = msg || '';
    w.err.classList.toggle('is-on', !!msg);
  }

  function visibleReq(step) {
    /* R7: data-efq-req counts only while its group and its question are on screen */
    var out = [], qs = step.querySelectorAll('[data-efq-qcond]:not([hidden]) [data-efq-req]:not([hidden])');
    for (var i = 0; i < qs.length; i++) out.push(qs[i]);
    return out;
  }
  function qAnswered(q) {
    var out = q.querySelector('[data-efq-multi-out]');
    if (out) return !!out.value;
    return !!q.querySelector('input[type="radio"]:checked');
  }
  function validate(w, step) {
    var req = step.getAttribute('data-efw-req');
    if (req) {
      if (!w.form.querySelector('input[name="' + req + '"]:checked')) {
        say(w, 'Pick one to continue.');
        var first = step.querySelector('.efq-choice input');
        if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
        return false;
      }
    }
    var reqs = visibleReq(step);
    for (var r = 0; r < reqs.length; r++) {
      if (qAnswered(reqs[r])) continue;
      say(w, 'Pick one to continue — "Not sure" is fine.');
      var f2 = reqs[r].querySelector('.efq-choice input');
      if (f2) { try { f2.focus({ preventScroll: true }); } catch (e) { f2.focus(); } }
      return false;
    }
    /* Native validity, but only on controls that are really on screen, so the
       browser is never asked to point a bubble at something it cannot focus. */
    var ctrls = step.querySelectorAll('input:not([type="radio"]):not([type="file"]):not([type="hidden"]), textarea');
    for (var i = 0; i < ctrls.length; i++) {
      if (ctrls[i].checkValidity()) continue;
      say(w, ctrls[i].validationMessage || 'Check this field.');
      ctrls[i].reportValidity();
      return false;
    }
    say(w, '');
    return true;
  }

  function focusStep(w, step) {
    var el = step.querySelector('.efq-choice input:checked') ||
             step.querySelector('.efq-choice input') ||
             step.querySelector('.efq-input, .efq-textarea') ||
             step.querySelector('.efq-drop');
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (e2) { /* noop */ } }
  }

  function render(w, dir, moveFocus) {
    var list = order(w);
    if (list.indexOf(w.at) === -1) w.at = list[0];
    var idx = list.indexOf(w.at);
    var total = list.length;

    for (var i = 0; i < w.steps.length; i++) {
      var on = w.steps[i] === w.at;
      w.steps[i].hidden = !on;
      w.steps[i].classList.toggle('is-on', on);
    }

    w.fill.style.width = Math.round(((idx + 1) / total) * 100) + '%';
    /* The count is written into a fixed-width box so the element's rect never
       moves — a text change inside a stable box is not a layout shift. */
    w.count.setAttribute('data-efw-text', 'Step ' + (idx + 1) + ' of ' + total);
    w.live.textContent = 'Step ' + (idx + 1) + ' of ' + total + ': ' + stepName(w.at);

    w.back.hidden = idx === 0;
    var last = idx === total - 1;
    w.next.hidden = last;
    if (w.send) w.send.hidden = !last;
    if (w.schedule) w.schedule.hidden = !last;
    w.form.setAttribute('data-efw-at', w.at.getAttribute('data-efw-key') || '');
    say(w, '');

    if (last) summarise(w, list);

    if (dir && !reduced()) {
      w.at.classList.remove('efw-in-f', 'efw-in-b');
      /* force a reflow so the animation restarts on every move */
      void w.at.offsetWidth;
      w.at.classList.add(dir > 0 ? 'efw-in-f' : 'efw-in-b');
    }
    w.area.scrollTop = 0;
    if (moveFocus) { keepInView(w); focusStep(w, w.at); }
  }

  /* In the modal the panel IS the viewport, so this can never bite. On the page
     it can: answer a question near the bottom of the screen, advance, and the
     next question is above the fold with nothing apparently having happened.
     Measured 2026-09-01 (walkthrough/tqw-escape-d1440-photo.png). Only ever
     scrolls when the frame's top has actually gone past the sticky header, and
     scrolling is not a layout shift, so the CLS gate is untouched. */
  function keepInView(w) {
    if (w.frame.closest('dialog')) return;
    var hdr = document.querySelector('.efx-header');
    var pad = (hdr ? hdr.getBoundingClientRect().height : 64) + 16;
    var top = w.frame.getBoundingClientRect().top;
    if (top >= pad - 1) return;
    window.scrollBy({ top: top - pad, left: 0, behavior: reduced() ? 'auto' : 'smooth' });
  }

  function stepName(step) {
    return step.getAttribute('data-efw-sum') || text(step.querySelector('.efq-step__legend'));
  }

  function go(w, delta) {
    var list = order(w);
    var idx = list.indexOf(w.at);
    var to = idx + delta;
    if (to < 0 || to >= list.length) return;
    if (delta > 0 && !validate(w, w.at)) return;
    w.at = list[to];
    render(w, delta, true);
  }

  function jump(w, step) {
    if (!step) return;
    w.at = step;
    render(w, -1, true);
  }

  /* -------------------------------------------------------------- summary -- */
  function valueOf(w, step) {
    var key = step.getAttribute('data-efw-key');
    if (key === 'size') {
      var flag = step.querySelector('[data-efq-nomeasure]');
      if (flag && flag.checked) return 'Not measured yet — send the guide';
      var parts = [];
      var fields = [['#efq-w', '[data-efw-wlabel]'], ['#efq-h', '[data-efw-hlabel]'], ['#efq-d', '[data-efw-dlabel]']];
      for (var f = 0; f < fields.length; f++) {
        var inp = step.querySelector(fields[f][0]), lab = step.querySelector(fields[f][1]);
        if (!inp || !inp.value.trim()) continue;
        var wrap = inp.closest('.efq-field'); if (wrap && wrap.hidden) continue;
        parts.push((lab ? lab.textContent : '') + ' ' + inp.value.trim() + ' in');
      }
      return parts.join(' · ');
    }
    if (key === 'spec') {
      var vals = [], on = step.querySelectorAll('[data-efq-qcond]:not([hidden]) .efq-q:not([hidden])');
      for (var s2 = 0; s2 < on.length; s2++) {
        var out = on[s2].querySelector('[data-efq-multi-out]');
        if (out) { if (out.value) vals.push(out.value); continue; }
        var pk = on[s2].querySelector('input[type="radio"]:checked');
        if (pk) vals.push(pk.value);
      }
      return vals.join(' · ');
    }
    if (key === 'photo') {
      var f = step.querySelector('input[type="hidden"][name="contact[Photos]"]');
      var n = f && f.value ? f.value.split(/\s{2,}/).filter(Boolean).length : 0;
      return n ? (n === 1 ? '1 photo attached' : n + ' photos attached') : '';
    }
    if (key === 'contact') {
      var nm = step.querySelector('#efq-name'), em = step.querySelector('#efq-email');
      var parts = [];
      if (nm && nm.value.trim()) parts.push(nm.value.trim());
      if (em && em.value.trim()) parts.push(em.value.trim());
      var cw = step.querySelector('input[name="contact[Call window]"]:checked');
      if (cw) parts.push(cw.value === 'Email only, please' ? 'email only' : 'call ' + (cw.value === 'Any time in business hours' ? 'any time' : cw.value.toLowerCase()));
      return parts.join(' · ');
    }
    var picked = step.querySelector('.efq-choice input:checked');
    return picked ? picked.value : '';
  }

  function summarise(w, list) {
    var box = w.form.querySelector('[data-efw-summary]');
    if (!box) return;
    var dl = document.createElement('dl');
    dl.className = 'efw-sum__list';
    var rows = 0;
    for (var i = 0; i < list.length; i++) {
      var step = list[i];
      if (step.getAttribute('data-efw-key') === 'review' || step.getAttribute('data-efw-key') === 'contact') continue;
      var v = valueOf(w, step);
      if (!v) continue;
      var dt = document.createElement('dt');
      dt.textContent = step.getAttribute('data-efw-sum') || stepName(step);
      var dd = document.createElement('dd');
      var span = document.createElement('span');
      span.textContent = v;
      var edit = document.createElement('button');
      edit.type = 'button';
      edit.className = 'efw-sum__e';
      edit.textContent = 'Edit';
      edit.setAttribute('aria-label', 'Edit ' + (step.getAttribute('data-efw-sum') || stepName(step)));
      (function (s) { edit.addEventListener('click', function () { jump(w, s); }); })(step);
      dd.appendChild(span);
      dd.appendChild(edit);
      dl.appendChild(dt);
      dl.appendChild(dd);
      rows++;
    }
    var ref = w.form.querySelector('[data-efq-ref]');
    if (ref && ref.value) {
      var rdt = document.createElement('dt'); rdt.textContent = 'Reference';
      var rdd = document.createElement('dd'); var rsp = document.createElement('span'); rsp.className = 'efq-ref__code'; rsp.textContent = ref.value; rdd.appendChild(rsp);
      dl.appendChild(rdt); dl.appendChild(rdd); rows++;
    }
    box.innerHTML = '';
    if (!rows) { box.hidden = true; return; }
    var h = document.createElement('p');
    h.className = 'efw-sum__h';
    h.textContent = 'What we will send';
    box.appendChild(h);
    box.appendChild(dl);
    box.hidden = false;
  }

  /* ----------------------------------------------------------------- wire -- */
  function wire(w) {
    w.next.addEventListener('click', function () { go(w, 1); });
    w.back.addEventListener('click', function () { go(w, -1); });

    /* Auto-advance is deliberately bound to a real pointer click (detail > 0).
       `change` would fire on every arrow-key press inside a radio group and fling
       a keyboard user forward; the browser's own roving stays intact this way. */
    w.area.addEventListener('click', function (e) {
      if (!e.detail) return;
      var lab = e.target && e.target.closest ? e.target.closest('.efq-choice') : null;
      if (!lab || !w.at.contains(lab)) return;
      if (w.at.getAttribute('data-efw-key') === 'spec') {
        /* R7: 1–3 questions on one screen — advance only from the last visible one,
           and only once every required question above it has an answer. */
        var qs = w.at.querySelectorAll('[data-efq-qcond]:not([hidden]) .efq-q:not([hidden])');
        if (!qs.length || !qs[qs.length - 1].contains(lab)) return;
        if (lab.querySelector('input[type="checkbox"]')) return;    /* chips: several taps, no fling */
        var reqs = visibleReq(w.at);
        for (var r = 0; r < reqs.length; r++) if (reqs[r] !== qs[qs.length - 1] && !qAnswered(reqs[r])) return;
      } else if (!isChoiceOnly(w.at)) return;
      var list = order(w);
      if (list.indexOf(w.at) === list.length - 1) return;
      window.clearTimeout(w.timer);
      w.timer = window.setTimeout(function () {
        if (lab.querySelector('input') && lab.querySelector('input').checked) go(w, 1);
      }, 280);
    });

    w.form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.name) return;
      if (t.name === 'contact[Quote for]') { applyBranch(w); render(w, 0, false); }
      if (t.hasAttribute && t.hasAttribute('data-efq-nomeasure')) applyPhotoHelp(w);
    });

    w.form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.isComposing) return;
      var t = e.target;
      if (!t || !t.tagName) return;
      var tag = t.tagName.toLowerCase();
      if (tag === 'textarea' || tag === 'button' || tag === 'a') return;
      var list = order(w);
      var last = list.indexOf(w.at) === list.length - 1;
      if (tag === 'input') {
        e.preventDefault();
        if (last) { if (validate(w, w.at)) w.form.requestSubmit ? w.form.requestSubmit(w.send) : w.form.submit(); }
        else go(w, 1);
      }
    });

    /* Capture validation precedes quote intent/locking and the platform handoff.
       Nothing may submit from a step that is not the last one,
       whatever fires it. The native post is the only submit path and it happens
       once, from the review step. */
    w.form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) { e.stopImmediatePropagation(); return; }
      var list = order(w);
      if (list.indexOf(w.at) !== list.length - 1) { e.preventDefault(); e.stopImmediatePropagation(); go(w, 1); return; }
      for (var i = 0; i < list.length; i++) {
        if (validate(w, list[i])) continue;
        e.preventDefault();
        e.stopImmediatePropagation();
        jump(w, list[i]);
        return;
      }
      w.form.dispatchEvent(new CustomEvent('efq:validated-submit', { detail: { submitEvent: e } }));
    }, true);
  }

  /* ----------------------------------------------------------------- boot -- */
  function boot(formEl) {
    var form = formEl || document.getElementById('efq-form');
    if (!form) return null;
    if (form.getAttribute('data-efw-booted') === '1') {
      if (W && W.form === form) {
        var restored = form.getAttribute('data-efw-restore');
        if (restored === 'review') restored = 'contact';
        if (restored) {
          var restoredStep = form.querySelector('[data-efw-key="' + restored.replace(/"/g, '') + '"]');
          if (restoredStep && available(W, restoredStep)) W.at = restoredStep;
          form.removeAttribute('data-efw-restore');
        }
        applyBranch(W); applyPhotoHelp(W); render(W, 0, false);
      }
      return W;
    }
    if (!form.querySelector('[data-efw-step]')) return null;   /* success state */
    form.setAttribute('data-efw-booted', '1');

    var w = build(form);
    if (!w) return null;
    W = w;
    wire(w);
    applyBranch(w);
    applyPhotoHelp(w);

    /* Come back to where they were: efx-quote.js parks the step key with the
       one-shot draft, so a refresh, a bounced post or an accidental close lands
       on the question they were answering rather than at the start. */
    var back = form.getAttribute('data-efw-restore');
    if (back === 'review') back = 'contact';
    if (back) {
      var target = form.querySelector('[data-efw-key="' + back.replace(/"/g, '') + '"]');
      if (target && available(w, target)) w.at = target;
      form.removeAttribute('data-efw-restore');
    }
    render(w, 0, false);
    return w;
  }

  window.EFQuoteWizard = {
    boot: boot,
    at: function () { return W ? (W.at.getAttribute('data-efw-key') || '') : ''; },
    total: function () { return W ? order(W).length : 0; },
    index: function () { return W ? order(W).indexOf(W.at) : -1; },
    go: function (n) { if (W) go(W, n); }
  };

  /* Either load order works: efx-quote.js calls boot() at the end of its own
     boot, and this runs when the file lands after the form is already there. */
  function selfBoot() { if (document.getElementById('efq-form')) boot(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', selfBoot);
  else selfBoot();
})();
